// Tenant control over the live availability badge ("4 left") shown on
// booking forms and event cards. Two settings keys drive it:
//   settings.availability_badge        — "shown" | "hidden"; anything else
//                                        (or the key absent) means shown.
//   settings.availability_badge_label  — wording template containing
//                                        "{count}"; absent/blank falls back
//                                        to "{count} left".
// Resolve once from the widget settings jsonb, then format per remaining
// count wherever the badge renders.

export type AvailabilityBadge = { shown: boolean; label: string };

const DEFAULT_LABEL = "{count} left";

export function resolveAvailabilityBadge(
  settings: Record<string, unknown> | null | undefined,
): AvailabilityBadge {
  const shown = settings?.availability_badge !== "hidden";
  const rawLabel = settings?.availability_badge_label;
  const label =
    typeof rawLabel === "string" && rawLabel.trim() !== ""
      ? rawLabel
      : DEFAULT_LABEL;
  return { shown, label };
}

export function formatBadge(badge: AvailabilityBadge, n: number): string {
  return badge.label.replace("{count}", String(n));
}
